Ctrl.$inject = ['$scope'];

function Ctrl($scope) {
	$scope.archiveYear = 2025;
	$scope.setArchiveTab = function (int) {
		$scope.archiveYear = int;
	};
}
module.exports = Ctrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/agreements-archive/controllers/agreementsArchive.js
 ** module id = 257
 ** module chunks = 1
 **/